import React from 'react';
import { useLocation } from 'react-router-dom';
import { FormikErrors, FormikTouched } from 'formik';
import * as Yup from 'yup';
import Wizard from '@service-victoria/component-library/components/Wizard';
import {
  Step as StepProps,
  Storage,
  AppContextStates
} from '@service-victoria/component-library/components/Wizard/props';
import { storage as storageUtils } from '@service-victoria/component-library/utils/storage';

import * as Interfaces from 'interfaces';
import { app as appContext } from 'context';
import * as Steps from 'steps';
import { constants, storage } from 'utils';
import { noop } from 'lodash-es';

const scrollOptions: ScrollToOptions = {
  behavior: 'smooth',
  top: 80
};

const Transaction: React.FC = () => {
  // The wizard was created with "hash" url support, so we need to extract its value to know at what step the user was
  const location = useLocation();
  const context = appContext.useAppContext();
  const { hash } = location;

  // Get the current hash value of the url to set initialStep index (to load the user in same step in case the screen got refershed in middle of the process)
  // const initialStepId = hash.substr(1) ? hash.substr(1) : Steps.Step1.Step.id;
  const initialStepId = hash.substr(1) ? hash.substr(1) : Steps.Identity.Step.id;

  const steps: StepProps<any>[] = [
    Steps.Identity.Step,
    Steps.Assess.Step,
    Steps.Review.Step,
    Steps.Done.Step
  ];

  /**
   * Try to load existing form state from the browser storage in case of user refresh
   */
  const initialState = storage.getStorage<Interfaces.Common.FormValues>(
    constants.StorageKeys.Wizard
  );

  const initialValues: Interfaces.Common.FormValues = {
    identity: initialState.identity ?? Steps.Identity.initialValues.identity,
    assess: initialState.assess ?? Steps.Assess.initialValues.assess,
    consent: initialState.consent ?? Steps.Review.initialValues.consent
  };
  const initialErrors: FormikErrors<Interfaces.Common.FormValues> = {
    ...Steps.Identity.initialErrors,
    ...Steps.Assess.initialErrors,
    ...Steps.Review.initialErrors
  };
  const initialTouched: FormikTouched<Interfaces.Common.FormValues> = {
    ...Steps.Identity.initialTouched,
    ...Steps.Assess.initialTouched,
    ...Steps.Review.initialTouched
  };

  const validationSchema = Yup.object().shape<Interfaces.Common.FormValues>({
    identity: Steps.Identity.wizardSchema,
    assess: Steps.Assess.wizardSchema,
    ...Steps.Review.wizardSchema
  });

  const wizardStorage: Storage<Interfaces.Common.FormValues> = {
    key: constants.StorageKeys.Wizard,
    loadOnMount: true,
    ...storageUtils(sessionStorage)
  };

  const initialAppStates: AppContextStates = {
    [constants.StorageKeys.State]: context
  };

  return (
    <Wizard
      headerProps={{
        fetchItemsFromAPI: true,
        showSideNav: true
      }}
      initialAppStates={initialAppStates}
      initialValues={initialValues}
      initialTouched={initialTouched}
      initialErrors={initialErrors}
      storage={wizardStorage}
      onWindowClose={noop}
      validationSchema={validationSchema}
      steps={steps}
      initialStepId={initialStepId}
      isStepperEnabed
      isHashEnabled
      scrollOptions={scrollOptions}
      breadCrumbs={constants.breadCrumbs}
      scrollOnSubmitError={true}
    />
  );
};

export default Transaction;
